import moment from "moment/moment";
import {readSessionTime} from "../services/localStorage.service";
import {SESSION_PARAMS} from "../constants/sessionParams";

const isSessionValid = () => {
    const sessionDateFinal = moment(new Date(readSessionTime())).add(SESSION_PARAMS.initialMinute+1,'m').toDate();
    return !(!readSessionTime() || sessionDateFinal < new Date())
}
export default isSessionValid;